'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import Text, { TextProps } from '../text'

/* -----------------------------------------------------------------------------
 * HeaderTitle
 * -------------------------------------------------------------------------- */

export type HeaderTitleProps = TextProps & {}

function HeaderTitle(props: HeaderTitleProps) {
  return (
    <Text variant='title' textAlign='center' alignSelf='center' {...props} />
  )
}

export default HeaderTitle
